import React from 'react';
import { IonButton, IonContent } from '@ionic/react';
import Loading from '../../components/spinner';
import { withTranslation } from '../../lib/translate';
import { isWebConfig } from '../../lib/utils';
import Layout from '../../components/layout';
import { Title } from '../../components/common';
import Incrementer from '../../components/incrementer';
import Basket from '../../lib/basket';

import './index.css';
import { getConfig } from '../../appConfig';

class ServiceChargeRaw extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      serviceCharge: 0,
      serviceChargePercentage: 0,
    };
  }
  componentDidMount() {
    const basketInstance = this.props.basketInstance || Basket;
    const currentServicePercentage = basketInstance.getServicePercentage();
    this.setState({
      serviceCharge: basketInstance._getServiceCharge(),
      serviceChargePercentage: currentServicePercentage,
    });
  }
  onIncrementerUpdate = (serviceChargePercentage) => {
    const basketInstance = this.props.basketInstance || Basket;
    basketInstance.setServicePercentage(serviceChargePercentage);
    this.setState({ serviceChargePercentage, serviceCharge: basketInstance._getServiceCharge() });
  };

  setServiceCharge(num) {
    const basketInstance = this.props.basketInstance || Basket;
    basketInstance.setServicePercentage(num);
    this.setState({
      serviceChargePercentage: num,
      serviceCharge: basketInstance._getServiceCharge(),
    });
  }
  applyServiceCharge() {
    this.props.handleServiceChargeModal(false);
  }
  clearServiceCharge() {
    const basketInstance = this.props.basketInstance || Basket;
    basketInstance.setServicePercentage(0);
    this.setState({ serviceCharge: 0, serviceChargePercentage: 0 }, () => {
      this.applyServiceCharge();
    });
  }
  render() {
    const { __ } = this.props;
    const basketInstance = this.props.basketInstance || Basket;
    let service_charge_original;
    if (basketInstance.getRestaurantServiceCharge()) {
      service_charge_original = basketInstance.getRestaurantServiceCharge();
    } else {
      service_charge_original = JSON.parse(getConfig().general.defaultServiceCharge);
    }

    const service_charge = service_charge_original.map((el) => Number((el * 100).toFixed(2)));
    const { serviceCharge, serviceChargePercentage } = this.state;
    return (
      <IonContent>
        <div className="absolute-content flex-row-wrapper service-charge">
          <div className="scrollable-y checkout flex-row-wrapper ">
            <Title className="okx-font-secondary">{__('Service charge')}</Title>
            <div className="service-charge-content ">
              <div className="service-charge-incrementer-wrapper">
                <p>Total Order Value {basketInstance._getTotal(true)}</p>
                <Incrementer
                  onUpdate={this.onIncrementerUpdate}
                  quantity={serviceChargePercentage}
                  step={1}
                  allowNegative={false}
                  note="%"
                />
                <p>
                  {__('Service charge')} {basketInstance.getServiceCharge()}
                </p>
                <div className="incrementer-buttons">
                  {service_charge.map((item) => {
                    return (
                      <IonButton
                        key={item + 'service_charge'}
                        expand="block"
                        color="primary"
                        onClick={() => {
                          this.setServiceCharge(item);
                        }}
                      >
                        <strong className="uppercase">{item}% </strong>
                      </IonButton>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="flex-min service-charge-buttons">
              <IonButton
                expand="block"
                color="primary"
                onClick={this.applyServiceCharge.bind(this)}
              >
                <strong className="uppercase">APPLY</strong>
              </IonButton>
              <IonButton
                expand="block"
                fill="clear"
                color="primary"
                className="link underlined"
                onClick={this.clearServiceCharge.bind(this)}
              >
                <strong>No thanks</strong>
              </IonButton>
            </div>
          </div>
        </div>
      </IonContent>
    );
  }
}

export const ServiceCharge = withTranslation(ServiceChargeRaw);

const ServiceChargeWrapper = (props) => (
  <Loading>
    <Layout headerTitle={props.__('Redeem Points')}>
      <ServiceCharge {...props} />
    </Layout>
  </Loading>
);

export default withTranslation(ServiceChargeWrapper);
